<template>
  <div id="app">
    <Navbar />
    <router-view />
    <br />
    <Footer />
  </div>
</template>

<script>
import Navbar from './components/navigation/Navbar.vue'
import Footer from "./components/Footer";

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
